import type { CSSProperties } from "react";

type BadgeVariant = "success" | "warning" | "error" | "neutral" | "accent";

interface BadgeProps {
  label: string;
  variant?: BadgeVariant;
  className?: string;
  style?: CSSProperties;
}

const variantColors: Record<BadgeVariant, { bg: string; text: string }> = {
  success: { bg: "rgba(22, 163, 74, 0.08)", text: "var(--color-success-text)" },
  warning: { bg: "rgba(234, 88, 12, 0.08)", text: "var(--color-warning-orange-dark)" },
  error: { bg: "rgba(220, 38, 38, 0.08)", text: "var(--color-error-text)" },
  neutral: { bg: "var(--ish-border-light, #f5f5f4)", text: "var(--ish-text-muted)" },
  accent: { bg: "var(--ish-accent-light)", text: "var(--ish-accent)" },
};

export default function Badge({ label, variant = "neutral", className, style }: BadgeProps) {
  const v = variantColors[variant];
  return (
    <span
      className={className}
      style={{
        display: "inline-block",
        backgroundColor: v.bg,
        color: v.text,
        borderRadius: 9999,
        padding: "2px 10px",
        fontSize: 11,
        fontWeight: 600,
        lineHeight: "14px",
        ...style,
      }}
    >
      {label}
    </span>
  );
}
